var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-query";
import { FormattedMessage, useIntl } from "react-intl";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Pane, Row, Col, PaneFooter, AccordionSet, Accordion, Checkbox, ErrorModal, } from "@folio/stripes/components";
import { RecekSelection, RecekTextField } from "../../components/inputs";
import { fetchOrganizationOptions } from "../../api/organizationService";
import { usePickerOptions } from "../../hooks/usePickerOptions";
import { PickerHint } from "../../components/PickerHint";
import { assignUserToOrganization, createUser, fetchCurrentUser, } from "../../api/usersService";
import { createUserSchema } from "../../utils/validationUtils";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { NK_ORG_UUID } from "../../utils/constants";
import { hasRole, useActiveRoles } from "../../utils/permissionsUtils";
import { RoleEnum } from "../../types/RoleEnum";
import { useScrollToError } from "../../hooks/useScrollToError";
import { ROLE_VALIDATION_ERRORS } from "../../utils/handleUserEditErrors";
import { ExportApiClientRoleCheckbox } from "../../components/ExportApiClientRoleCheckbox";
import { isRoleLockedByExportApiClient } from "../../utils/exportApiClientExclusivity";
/** Roles offered only for the NK organization (see showNKSpecialRoles). */
var NK_SPECIAL_ROLES = [
    RoleEnum.COLLECTIONS_ADMINISTRATOR,
    RoleEnum.ONIX_CODETABLES_ADMINISTRATOR,
    RoleEnum.EXPORT_API_CLIENT,
];
var extendedUserSchema = function (intl) {
    return createUserSchema(intl).extend({
        organization: z.string().min(1, {
            message: intl.formatMessage({
                id: "ui-br-users.users.validation.organization",
            }),
        }),
        selectedRoles: z.array(z.string()).optional(),
    });
};
var UserCreate = function () {
    var _a, _b, _c, _d, _e, _f;
    var history = useHistory();
    var ky = useOkapiKy();
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var _g = useForm({
        resolver: zodResolver(extendedUserSchema(intl)),
        defaultValues: {
            user: {
                email: "",
                firstName: "",
                lastName: "",
                shouldChangePassword: true,
            },
            password: "",
            sendEmail: true,
            organization: "",
            selectedRoles: [],
        },
        mode: "onBlur",
    }), handleSubmit = _g.handleSubmit, register = _g.register, setValue = _g.setValue, getValues = _g.getValues, watch = _g.watch, control = _g.control, errors = _g.formState.errors;
    var _h = useState(true), expandAll = _h[0], setExpandAll = _h[1];
    var _j = useState({
        organization: true,
        profile: true,
        role: true,
    }), accordionStatus = _j[0], setAccordionStatus = _j[1];
    useScrollToError(errors);
    var _k = useState({ name: "" }), filters = _k[0], setFilters = _k[1];
    // DB-876: debounced, abortable search-as-you-type; a full page asks to refine the search
    var _l = usePickerOptions(filters.name, function (name, signal) {
        return fetchOrganizationOptions(ky, name, signal).then(function (page) { var _a; return (_a = page.organizations) !== null && _a !== void 0 ? _a : []; });
    }), organizationOptions = _l.options, isFetching = _l.loading, organizationsTruncated = _l.truncated;
    var _m = useState(false), errorModalOpen = _m[0], setErrorModalOpen = _m[1];
    var _o = useState(""), errorMessage = _o[0], setErrorMessage = _o[1];
    var handleChange = function (e) {
        var _a = e.target, name = _a.name, type = _a.type, value = _a.value;
        if (type === "checkbox") {
            var checked = e.target.checked;
            if (name === "sendEmail" || name === "user.shouldChangePassword") {
                setValue(name, checked, {
                    shouldValidate: true,
                });
                return;
            }
            if (name.startsWith("role_")) {
                var roleCode_1 = name.replace("role_", "");
                var currentRoles = getValues("selectedRoles") || [];
                var updatedRoles = checked
                    ? __spreadArray(__spreadArray([], currentRoles, true), [roleCode_1], false) : currentRoles.filter(function (role) { return role !== roleCode_1; });
                setValue("selectedRoles", updatedRoles, { shouldValidate: true });
                return;
            }
        }
        setValue(name, value, { shouldValidate: true });
    };
    var _p = useQuery(["currentUser"], function () { return fetchCurrentUser(ky); }, { staleTime: Infinity }), currentUser = _p.data, isCurrentUserLoading = _p.isLoading;
    var activeRoles = useActiveRoles().roles;
    var isSuperUser = hasRole(activeRoles, RoleEnum.SUPERUSER);
    var isAgencyWorker = hasRole(activeRoles, RoleEnum.AGENCY_WORKER);
    var isAdminLegalDeposits = hasRole(activeRoles, RoleEnum.ADMIN_LEGAL_DEPOSITS);
    var isPublisherAdmin = hasRole(activeRoles, RoleEnum.PUBLISHER_ADMIN);
    var isOnlyPublisherAdmin = isPublisherAdmin && !isSuperUser && !isAgencyWorker && !isAdminLegalDeposits;
    useEffect(function () {
        var _a;
        if (isOnlyPublisherAdmin && ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) === null || _a === void 0 ? void 0 : _a.id)) {
            setValue("organization", currentUser.activeOrganization.id, {
                shouldValidate: true,
            });
        }
    }, [isOnlyPublisherAdmin, (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) === null || _a === void 0 ? void 0 : _a.id, setValue]);
    // watched, not read once: the role checkboxes and the NK-only roles must follow every change
    var selectedOrganization = watch("organization");
    var selectedRoles = (_b = watch("selectedRoles")) !== null && _b !== void 0 ? _b : [];
    var showAgencyWorkerCheckbox = !isCurrentUserLoading &&
        (isSuperUser ||
            (isAgencyWorker &&
                ((_c = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) === null || _c === void 0 ? void 0 : _c.id) === NK_ORG_UUID &&
                selectedOrganization === NK_ORG_UUID));
    var showNKSpecialRoles = (isSuperUser || isAgencyWorker) &&
        selectedOrganization === NK_ORG_UUID;
    var showDistributorRole = isSuperUser || isAgencyWorker;
    var showPublisherRoles = isSuperUser || !isAdminLegalDeposits;
    var showLegalDepositsRoles = isSuperUser || isAdminLegalDeposits;
    // DB-946: ExportApiClient excludes every other role of the new user
    var isRoleLocked = function (role) {
        return isRoleLockedByExportApiClient([selectedRoles], 0, role);
    };
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var organization, selectedRoles, userData, newUser, error_1, errMsg, response, emailExistsError, roleError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    organization = data.organization, selectedRoles = data.selectedRoles, userData = __rest(data, ["organization", "selectedRoles"]);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 8]);
                    return [4 /*yield*/, createUser(ky, userData)];
                case 2:
                    newUser = _a.sent();
                    if (!organization) return [3 /*break*/, 4];
                    return [4 /*yield*/, assignUserToOrganization(ky, newUser.id, organization, selectedRoles)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    history.goBack();
                    return [3 /*break*/, 8];
                case 5:
                    error_1 = _a.sent();
                    console.error("Error creating user or assigning roles:", error_1);
                    errMsg = "Došlo k chybě při vytváření uživatele. Zkuste to prosím znovu.";
                    if (!error_1.response) return [3 /*break*/, 7];
                    return [4 /*yield*/, error_1.response.json()];
                case 6:
                    response = _a.sent();
                    if (Array.isArray(response.errors)) {
                        response.errors.forEach(function (err) {
                            console.log("Response error message:", err.message);
                        });
                        emailExistsError = response.errors.find(function (err) { return err.message.includes("Key (email)"); });
                        if (emailExistsError) {
                            errMsg =
                                "Došlo k chybě při vytváření uživatele. Tento email již existuje.";
                        }
                        roleError = response.errors.find(function (err) {
                            return !!err.type && ROLE_VALIDATION_ERRORS.includes(err.type);
                        });
                        if (roleError) {
                            errMsg = roleError.message;
                        }
                    }
                    _a.label = 7;
                case 7:
                    setErrorMessage(errMsg);
                    setErrorModalOpen(true);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var toggleExpandCollapseAll = function () {
        setExpandAll(!expandAll);
        setAccordionStatus({
            organization: !expandAll,
            profile: !expandAll,
            role: !expandAll,
        });
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-users.users.pane.create.title",
            }), footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { type: "submit", buttonStyle: "primary", onClick: handleSubmit(onSubmit) },
                    React.createElement(FormattedMessage, { id: "ui-br-users.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.goBack(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-users.button.cancel" })) }) },
            React.createElement(ErrorModal, { open: errorModalOpen, label: "Chyba", content: errorMessage, onClose: function () { return setErrorModalOpen(false); } },
                React.createElement("div", null, errorMessage),
                React.createElement(Button, { onClick: function () { return setErrorModalOpen(false); } },
                    React.createElement(FormattedMessage, { id: "ui-br-users.button.close" }))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
                    React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default" }, expandAll ? (React.createElement(FormattedMessage, { id: "ui-br-users.button.collapse" })) : (React.createElement(FormattedMessage, { id: "ui-br-users.button.expand" }))))),
            React.createElement("form", { noValidate: true, onSubmit: handleSubmit(onSubmit) },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-users.users.accordion.label.organization",
                        }), open: accordionStatus.organization, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { organization: !accordionStatus.organization }));
                        } },
                        isOnlyPublisherAdmin ? (React.createElement(RecekTextField, { labelId: "ui-br-users.label.organization", value: (_e = (_d = currentUser === null || currentUser === void 0 ? void 0 : currentUser.activeOrganization) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "", disabled: true })) : (React.createElement(RecekSelection, { labelId: "ui-br-users.label.organization", asyncFilter: true, name: "organization", value: getValues("organization"), error: (_f = errors.organization) === null || _f === void 0 ? void 0 : _f.message, loading: isFetching, onChange: function (value) {
                                setValue("organization", value, { shouldValidate: true });
                                // the NK-only roles are hidden for another organization, so they must not stay selected
                                // unseen (an ExportApiClient left behind would also lock every other role)
                                if (value !== NK_ORG_UUID) {
                                    setValue("selectedRoles", (getValues("selectedRoles") || []).filter(function (role) { return !NK_SPECIAL_ROLES.includes(role); }), { shouldValidate: true });
                                }
                            }, onFilter: function (value) {
                                setFilters({ name: value });
                            }, dataOptions: organizationOptions.map(function (org) { return ({
                                value: org.id,
                                label: org.name,
                            }); }) })),
                        React.createElement(PickerHint, { truncated: organizationsTruncated })),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-users.users.accordion.label.profile",
                        }), open: accordionStatus.profile, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { profile: !accordionStatus.profile }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "user.firstName", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-users.users.field.label.firstName", required: true }, field, { error: (_c = (_b = errors.user) === null || _b === void 0 ? void 0 : _b.firstName) === null || _c === void 0 ? void 0 : _c.message })));
                                    } })),
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "user.lastName", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-users.users.field.label.lastName", required: true }, field, { error: (_c = (_b = errors === null || errors === void 0 ? void 0 : errors.user) === null || _b === void 0 ? void 0 : _b.lastName) === null || _c === void 0 ? void 0 : _c.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "user.email", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-users.users.field.label.email", required: true }, field, { error: (_c = (_b = errors === null || errors === void 0 ? void 0 : errors.user) === null || _b === void 0 ? void 0 : _b.email) === null || _c === void 0 ? void 0 : _c.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 6 },
                                React.createElement(Controller, { control: control, name: "password", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({ labelId: "ui-br-users.users.field.label.password", required: true }, field, { error: (_b = errors === null || errors === void 0 ? void 0 : errors.password) === null || _b === void 0 ? void 0 : _b.message })));
                                    } }),
                                React.createElement("p", null, formatMessage({
                                    id: "ui-br-users.users.field.help.passwordLength",
                                })))),
                        React.createElement(Checkbox, __assign({ label: formatMessage({
                                id: "ui-br-users.users.checkbox.label.sendEmail",
                            }) }, register("sendEmail"), { checked: getValues("sendEmail"), onChange: handleChange }))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-users.users.accordion.label.role",
                        }), open: accordionStatus.role, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { role: !accordionStatus.role }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                showPublisherRoles && (React.createElement(React.Fragment, null,
                                    React.createElement(Checkbox, { label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.publisherAdmin",
                                        }), name: "role_PublisherAdmin", checked: selectedRoles.includes("PublisherAdmin"), disabled: isRoleLocked("PublisherAdmin"), onChange: handleChange }),
                                    React.createElement(Checkbox, { label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.publisherGuarantor",
                                        }), name: "role_PublisherGuarantor", checked: selectedRoles.includes("PublisherGuarantor"), disabled: isRoleLocked("PublisherGuarantor"), onChange: handleChange }))),
                                showAgencyWorkerCheckbox && (React.createElement(Checkbox, { name: "role_AgencyWorker", label: formatMessage({
                                        id: "ui-br-users.users.organization.roles.checkbox.label.agencyWorker",
                                    }), checked: selectedRoles.includes("AgencyWorker"), disabled: isRoleLocked("AgencyWorker"), onChange: handleChange })),
                                showNKSpecialRoles && (React.createElement(React.Fragment, null,
                                    React.createElement(Checkbox, { name: "role_CollectionsAdministrator", label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.collectionsAdministrator",
                                        }), checked: selectedRoles.includes("CollectionsAdministrator"), disabled: isRoleLocked("CollectionsAdministrator"), onChange: handleChange }),
                                    React.createElement(Checkbox, { name: "role_OnixCodetablesAdministrator", label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.onixCodetablesAdministrator",
                                        }), checked: selectedRoles.includes("OnixCodetablesAdministrator"), disabled: isRoleLocked("OnixCodetablesAdministrator"), onChange: handleChange }),
                                    React.createElement(ExportApiClientRoleCheckbox, { name: "role_".concat(RoleEnum.EXPORT_API_CLIENT), disabled: isRoleLocked(RoleEnum.EXPORT_API_CLIENT), checked: selectedRoles.includes(RoleEnum.EXPORT_API_CLIENT), onChange: handleChange }))),
                                showDistributorRole && (React.createElement(Checkbox, { name: "role_Distributor", label: formatMessage({
                                        id: "ui-br-users.users.organization.roles.checkbox.label.distributor",
                                    }), checked: selectedRoles.includes("Distributor"), disabled: isRoleLocked("Distributor"), onChange: handleChange })),
                                showLegalDepositsRoles && (React.createElement(React.Fragment, null,
                                    React.createElement(Checkbox, { name: "role_AdminLegalDeposits", label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.adminLegalDeposits",
                                        }), checked: selectedRoles.includes("AdminLegalDeposits"), disabled: isRoleLocked("AdminLegalDeposits"), onChange: handleChange }),
                                    React.createElement(Checkbox, { name: "role_LibrarianLegalDepositsMonographs", label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.librarianLegalDepositsMonographs",
                                        }), checked: selectedRoles.includes("LibrarianLegalDepositsMonographs"), disabled: isRoleLocked("LibrarianLegalDepositsMonographs"), onChange: handleChange }),
                                    React.createElement(Checkbox, { name: "role_LibrarianLegalDepositsPeriodicals", label: formatMessage({
                                            id: "ui-br-users.users.organization.roles.checkbox.label.librarianLegalDepositsPeriodicals",
                                        }), checked: selectedRoles.includes("LibrarianLegalDepositsPeriodicals"), disabled: isRoleLocked("LibrarianLegalDepositsPeriodicals"), onChange: handleChange })))))))))));
};
export default UserCreate;
